
const schema = {
        "definitions": {},
        "$schema": "http://json-schema.org/draft-07/schema#",
        "type": "object",
        "title": "The Root Schema",
        "required": [
          "status",
          "error",
          "user",
          "module",
          "viewer"
        ],
        "properties": {
          "status": {
            "$id": "#/properties/status",
            "type": "string"
          },
          "error": {
            "$id": "#/properties/error",
            "type": "string"
          },
          "user": {
            "$id": "#/properties/user",
            "type": "object"
          },
          "module": {
            "$id": "#/properties/module",
            "type": "object"
          },
          "viewer": {
            "$id": "#/properties/viewer",
            "type": "object"
          }
        }
      }

  export default schema;